import React, { useEffect, useState } from 'react'
import { Get_Api } from '../ApiUrls';
import AllCategory1 from '../Assets/ResidentialProperties1.png';
import { useNavigate } from 'react-router-dom';

function AllBlogs() {
    const navigate = useNavigate()
    const [AllBlogs, setAllBlogs] = useState([]);

    const [IsUploading, setIsUploading] = useState(false);

    const GetAllBlogs = async () => {
        try {
            setIsUploading(true)
            const response = await Get_Api(`api/admin/GetAllBlogs`)
            setAllBlogs(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetAllBlogs();
    }, []);

    const Blogdetails = (id) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/BlogDetails/${id}`)
    }

    return (
        <>
            <div className="container">
                <div className="property-grid">
                    {AllBlogs?.length > 0 ? (
                        AllBlogs?.map((Blog, index) => (
                            <div className="property-card" key={index}>
                                <div className="image-wrapper">
                                    <img
                                        src={Blog?.Image || AllCategory1}
                                        alt={Blog?.Name}
                                        className="property-image"
                                    />
                                    <div onClick={() => { Blogdetails(Blog?._id) }} className="overlay">View Details ↗</div>
                                </div>
                                <h2 className="property-title">{Blog?.Name}</h2>
                                <p className="blog-price">{Blog?.Detail?.slice(0,50)}...</p>
                            </div>
                        ))
                    ) : (
                        <p className="no-properties-message">No Blogs Found.</p>
                    )}
                </div>
            </div>

        </>
    )
}

export default AllBlogs